exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CanvasInput_input_CmTZb{display:block;width:100%;padding:10px;margin:10px}.CanvasInput_switch_LuCwM{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"input": "CanvasInput_input_CmTZb",
	"switch": "CanvasInput_switch_LuCwM"
};